/** Small formatting helpers shared across pages. */

export const format = {
  /** kg → metric tonnes with 1 decimal, e.g. 15440 → "15.4". */
  tonnes(kg: number): string {
    if (!Number.isFinite(kg)) return "—";
    return (kg / 1000).toFixed(1);
  },
  int(n: number): string {
    return Number(n).toLocaleString();
  },
};
